export const processUserData = (data) => {
  return {
    ...data,
    updated_at_date: new Date(data.updated_at),
  };
};

export const getNameFromEmail = (email: string) =>
  (email || "")?.split("@")?.[0] || "";
